import React from 'react'
import { useParams } from 'react-router'
import DefaultDriverLayout from '../../../../../components/layout/DefaultDriverLayout'

const Earnings = () => {
  const { token } = useParams()

  return (
    <>
      <DefaultDriverLayout partnerToken={token} isPartnerEarnings />
    </>
  )
}

export default Earnings
